var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 648,
    height: 87,
    viewBox: "0 0 648 87",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M79.9101 2.7356V86.0001C78.8226 84.9579 58.704 63.3019 38.897 41.9926C17.9983 19.7587 1.31161 3.66218 1.31161 3.66218V83.8002H1V2.7356C3.96341 2.85116 6.77205 2.85116 9.7334 2.7356L79.5985 77.3162V2.7356H79.9101Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M186.362 83.8022L169.05 51.6071H121.326L103.395 83.8022H102.926L148.931 1C148.931 1 162.343 26.2447 176.223 51.9558C187.449 72.9164 194.782 83.8022 194.782 83.8022C191.973 83.5711 189.166 83.5711 186.362 83.8022ZM168.893 51.2604L145.345 8.17946L121.483 51.2604H168.893Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M262.36 85.5376C228.52 85.5376 205.752 68.6301 205.752 43.5009C205.752 18.3697 228.052 1.46216 261.896 1.46216C285.601 1.46216 297.139 9.33708 297.139 9.33708V12.9278C297.139 12.9278 287.939 1.69535 261.896 1.69535C231.172 1.69535 213.237 19.8762 213.237 43.503C213.237 67.1298 231.641 85.3106 262.36 85.3106C277.175 85.3106 286.845 82.1842 292.615 79.2868C292.615 56.8218 291.992 51.3779 291.992 51.3779C294.646 51.4935 297.296 51.4935 299.634 51.3779C299.634 51.3779 299.165 59.484 299.165 77.5492C299.165 77.5471 287.157 85.5376 262.36 85.5376Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M338.012 43.1523C338.012 17.3277 338.478 2.7356 338.478 2.7356C335.981 2.85116 333.331 2.85116 330.836 2.7356C330.836 2.7356 331.464 17.0945 331.464 43.2679C331.464 69.4413 330.836 83.8023 330.836 83.8023C333.333 83.6867 335.983 83.6867 338.478 83.8023C338.478 83.8023 338.012 69.3278 338.012 43.3855V43.1523Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M412.087 2.7356C409.594 2.85116 406.94 2.85116 404.445 2.7356C404.445 2.7356 405.072 17.3257 405.072 43.1523V43.3855C405.072 69.3257 404.445 83.8023 404.445 83.8023C406.942 83.6867 409.596 83.6867 412.087 83.8023C412.087 83.8023 411.62 69.4433 411.62 43.2679C411.62 17.0966 412.087 2.7356 412.087 2.7356Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M477.441 83.4534H450.617V43.3854V3.08424H477.441C495.999 3.08424 502.083 4.47308 504.423 5.74842L503.643 2.73755H443.287C443.287 2.73755 443.915 17.0965 443.915 43.2698C443.915 69.4432 443.287 83.8042 443.287 83.8042H504.266L505.046 80.7933C502.708 82.0645 495.999 83.4534 477.441 83.4534Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M528.174 83.8023C528.174 83.8023 528.801 69.4433 528.801 43.2679C528.801 17.0966 528.174 2.7356 528.174 2.7356H555.156C592.43 2.7356 615.976 18.3678 615.976 43.499C615.976 68.6282 592.118 83.8002 555.936 83.8002H528.174V83.8023ZM535.504 2.96673V83.5711H555.934C588.996 83.5711 608.177 67.1258 608.177 43.5011C608.177 19.8763 589.462 2.96673 555.154 2.96673H535.504V2.96673Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.5
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M639.419 83.8023C639.419 83.8023 640.047 69.4433 640.047 43.2679C640.047 17.0966 639.419 2.7356 639.419 2.7356C641.761 2.85116 644.411 2.85116 647.061 2.7356C647.061 2.7356 646.595 17.0945 646.595 43.2679C646.595 69.4413 647.061 83.8023 647.061 83.8023C644.564 83.6867 641.914 83.6867 639.419 83.8023Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.5
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M273.723 51.2336H493.837",
    stroke: "black",
    strokeWidth: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBlack);
export default __webpack_public_path__ + "static/media/logoBlack.5fd9c4119245e23d0651b8ee9b5ee868.svg";
export { ForwardRef as ReactComponent };